<button mat-raised-button (click)="logDimgRequest()">Preview DIMG Request</button>
